// extracted by mini-css-extract-plugin
export default {"paperContainer":"style_paperContainer__+KZPb","mainContainer":"style_mainContainer__0skPm","bajaTxt":"style_bajaTxt__3Sqsk"};